import { Action } from '@ngrx/store';

import { UserActionType } from './user-action-type.enum';

export class SelectUser implements Action {
  public readonly type: UserActionType = UserActionType.SelectUser;

  constructor(public readonly payload: number) { }
}

export class SelectUserCompleted implements Action {
  public readonly type: UserActionType = UserActionType.SelectUserCompleted;

  constructor(public readonly payload: number) { }
}

export class SelectUserFailed implements Action {
  public readonly type: UserActionType = UserActionType.SelectUserFailed;

  constructor(public readonly payload: string) { }
}

export class ResetSelectedUser implements Action {
  public readonly type: UserActionType = UserActionType.ResetSelectedUser;
  public readonly payload: string = undefined;
}
